import styled from 'styled-components';

const ClaroInputField = styled.input`
margin: ${props => props.margin ? props.margin : '0rem'};
padding: ${props => props.padding ? props.padding : '0rem'};
-webkit-appearance: none;
border-radius: 0;
height: ${props => props.height ? props.height : 'auto'};
min-height: ${props => props.height ? props.height : '34px'};
font-family: ${props => props.fontFamily ? props.fontFamily : 'AMX-Regular'};
font-weight: ${props => props.fontWeight ? props.fontWeight : ''};
color: ${props => props.color ? props.color : '#323232'};
font-size: ${props => props.fontSize ? props.fontSize : '0.7rem'};
line-height: ${props => props.lineHeight ? props.lineHeight : 'auto'};
vertical-align: ${props => props.verticalAlign ? props.verticalAlign : 'middle'};
border-style: ${props => props.borderStyle ? props.borderStyle : 'none'};
background: ${props => props.background ? props.background : 'transparent'};
border-bottom: ${props => props.borderBottom ? props.borderBottom : '1px solid #26012024'};
width: ${props => props.width ? props.width : 'auto'};
text-align: ${props => props.textAlign ? props.textAlign : 'left'};
outline: ${props => props.outline ? props.outline : 'none'}; 
flex-grow: ${props => props.flexGrow ? props.flexGrow : '1'};
text-transform: ${props => props.textTransform ? props.textTransform : 'initial'};
max-width: 100%;
::placeholder {
    margin: ${props => props.margin ? props.margin : '0rem'};
    padding: ${props => props.padding ? props.padding : '0rem'};
    color: ${props => props.phColor ? props.phColor : '#848484'};
    font-size: ${props => props.fontSize ? props.fontSize : '0.7rem'};
    line-height: ${props => props.lineHeight ? props.lineHeight : 'auto'};
    vertical-align: ${props => props.verticalAlign ? props.verticalAlign : 'middle'};
    font-family: ${props => props.fontFamily ? props.fontFamily : 'AMX-Regular'};
    text-align: ${props => props.textAlign ? props.textAlign : 'left'};
    font-weight: ${props => props.fontWeight ? props.fontWeight : ''};
    text-transform: ${"initial"};

}
`
export default ClaroInputField;